/* FÉNIX v71.66R16 — catalog-wide Quick Card normalizer
   Goals:
   - One runtime for mixed generations of product-description HTML.
   - Prefer authored quick/benefit cards when they exist.
   - Otherwise compose up to four concise cards from structured facts already
     present in the CURRENT product: headings + copy, tables, labeled lists,
     technical identity, then native Shopify product facts.
   - Never use a product-name/handle lookup table and never copy another
     product's content.
   - Rebuild when instant navigation reuses a product shell for a new product.
   - No visual ellipses: every displayed line is a complete source sentence,
     clause, or structured value. */
(function(){
  'use strict';

  var VERSION='71.66R16';
  if(window.NMGlobalQuickCards && window.NMGlobalQuickCards.version===VERSION){
    window.NMGlobalQuickCards.scan();
    return;
  }

  var EMOJI_RE=/[\u{1F000}-\u{1FAFF}\u2600-\u27BF]/u;
  var BLOCKED={
    'especificaciones':1,'datos esenciales':1,'lo esencial':1,'lo esencial en segundos':1,'resumen rapido':1,
    'informacion del producto':1,'ficha tecnica':1,'historia contexto':1,'ideal para':1,
    'que puedes esperar':1,'experiencia del usuario':1,'testimonios':1,'advertencias':1,
    'informacion importante':1,'modo de uso':1,'dosificacion':1,'dosis':1,'reconstitucion':1,
    'administracion':1,'almacenamiento':1,'precauciones':1
  };
  var QUICK_LABEL=/(?:beneficios?|benefits?|ventajas|resumen rapido|lo esencial en segundos|puntos clave|caracteristicas destacadas|por que podria interesarte|mecanismos? de accion|areas? de investigacion|investigacion documentada|mecanismos? principales|efectos principales)/;
  var UNSAFE_LABEL=/(?:advertencias?|precauciones?|contraindic|dosific|dosis|modo de uso|administracion|reconstitucion|inyectar|volumen sugerido|solvente recomendado)/;
  var scanning=false;
  var scheduled=0;

  function norm(value){
    return String(value||'').replace(/\u00a0/g,' ').replace(/\s+/g,' ').trim().toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g,'');
  }
  function text(el){ return String(el&&el.textContent||'').replace(/\s+/g,' ').trim(); }
  function direct(el,selector){
    if(!el) return null;
    for(var i=0;i<el.children.length;i+=1){
      var child=el.children[i];
      if(child.matches&&child.matches(selector)) return child;
    }
    return null;
  }
  function firstMeaningful(value){
    return String(value||'').replace(/[\u2026]+/g,'').replace(/\.{3,}/g,'').replace(/\s+/g,' ').trim();
  }
  function finish(value){
    var clean=firstMeaningful(value).replace(/^["“”'‘’]+|["“”'‘’]+$/g,'').trim();
    if(!clean) return '';
    if(!/[.!?)]$/.test(clean)) clean+='.';
    return clean;
  }
  function compactCopy(value){
    var clean=firstMeaningful(value);
    if(!clean) return '';
    if(clean.length<=120) return finish(clean);

    var sentences=clean.match(/[^.!?]+[.!?]+|[^.!?]+$/g)||[];
    for(var i=0;i<sentences.length;i+=1){
      var sentence=sentences[i].trim();
      if(sentence.length>=16&&sentence.length<=125) return finish(sentence);
    }

    var first=(sentences[0]||clean).trim();
    var clauses=first.split(/;\s+|,\s+(?=(?:que\b|y\b|pero\b|con\b|sin\b|para\b|por\b|en\b|la\b|el\b|los\b|las\b|un\b|una\b|[A-ZÁÉÍÓÚÑ]))/i);
    var out='';
    for(var j=0;j<clauses.length;j+=1){
      var clause=clauses[j].trim();
      if(!clause) continue;
      var candidate=(out?out+', ':'')+clause;
      if(candidate.length>118) break;
      out=candidate;
      if(out.length>=55) break;
    }
    if(out.length>=16) return finish(out);

    /* Preserve truth over forced brevity: a long source sentence is preferable
       to an artificial truncation or ellipsis. */
    return finish(first);
  }
  function compactTitle(value){
    return firstMeaningful(value).replace(/[.:;\-–—]+$/,'').trim();
  }

  function semanticIcon(title,desc){
    var value=norm((title||'')+' '+(desc||''));
    if(/memoria|aprendiz|cognit|claridad mental|neuroplastic/.test(value)) return '🧠';
    if(/enfoque|concentr|atencion|foco/.test(value)) return '🎯';
    if(/energia|fatiga|alerta|rendimiento|mitocond/.test(value)) return '⚡';
    if(/neurotrans|colina|dopamina|serotonina|acetilcolina|sinaps/.test(value)) return '🧬';
    if(/protec|antioxid|neuroprotec|defensa|integridad/.test(value)) return '🛡️';
    if(/estres|calma|animo|adaptogen|rhodiola|botanic|herbal|planta/.test(value)) return '🌿';
    if(/sueno|descanso|melatonina/.test(value)) return '🌙';
    if(/sinerg|combin|formula|stack/.test(value)) return '📊';
    if(/pureza|laboratorio|investig|analisis|hplc|grado quimico/.test(value)) return '🔬';
    if(/presentacion|capsul|tableta|pildora|vial|polvo|spray|formato|contenido|cantidad neta/.test(value)) return '💊';
    if(/absor|biodispon/.test(value)) return '🧪';
    if(/cas|formula molecular|peso molecular|masa molecular|secuencia|clase|clasificacion|compuesto|ingrediente activo/.test(value)) return '⚗️';
    if(/marca|fabricante|proveedor/.test(value)) return '🏷️';
    return '✨';
  }
  function detectIcon(el,title,desc){
    if(el){
      var nodes=el.querySelectorAll('div,span,strong,b');
      for(var i=0;i<nodes.length;i+=1){
        var value=text(nodes[i]);
        if(value&&value.length<=16&&EMOJI_RE.test(value)) return value;
      }
    }
    return semanticIcon(title,desc);
  }
  function unsafe(title,desc){
    var value=norm((title||'')+' '+(desc||''));
    return UNSAFE_LABEL.test(value);
  }
  function validCard(title,desc,productTitle){
    var t=compactTitle(title), d=firstMeaningful(desc), key=norm(t);
    if(!t||!d||t.length>110||d.length>700) return false;
    if(BLOCKED[key]||key===norm(productTitle)||unsafe(t,d)) return false;
    return true;
  }
  function candidate(title,desc,icon,score,sourceEl,kind){
    return {title:compactTitle(title),desc:firstMeaningful(desc),icon:icon||semanticIcon(title,desc),score:score||0,el:sourceEl||null,kind:kind||'derived'};
  }

  function cardData(el,productTitle){
    if(!el||el.querySelector('table,ul,ol,h1,h2')) return null;
    var heading=direct(el,'h3,h4');
    var paragraph=direct(el,'p');
    if(!heading||!paragraph) return null;
    var title=text(heading),desc=text(paragraph);
    if(!validCard(title,desc,productTitle)) return null;
    return candidate(title,desc,detectIcon(el,title,desc),300,el,'authored');
  }
  function usefulLooseText(value,full,productTitle){
    var key=norm(value);
    if(!value||value.length<3||value.length>600) return false;
    if(value===full||key===norm(productTitle)||BLOCKED[key]||UNSAFE_LABEL.test(key)) return false;
    if(/^\d{1,3}$/.test(value)||/^[\W_]+$/u.test(value)) return false;
    return true;
  }
  function looseCardData(el,productTitle){
    if(!el||el.querySelector('table,ul,ol,h1,h2')) return null;
    var full=text(el);
    if(full.length<20||full.length>1400) return null;
    var titleEl=null,title='';
    var preferred=el.querySelectorAll('h3,h4,strong,b');
    for(var i=0;i<preferred.length;i+=1){
      var pv=text(preferred[i]);
      if(usefulLooseText(pv,full,productTitle)&&pv.length<=100){titleEl=preferred[i];title=pv;break;}
    }
    if(!titleEl){
      var labels=el.querySelectorAll('div,span');
      for(var j=0;j<labels.length;j+=1){
        var node=labels[j],value=text(node),style=String(node.getAttribute('style')||'').toLowerCase(),cls=String(node.className||'').toLowerCase();
        if(!usefulLooseText(value,full,productTitle)||value.length>100) continue;
        if(EMOJI_RE.test(value)&&value.length<=16) continue;
        if(/font-weight\s*:\s*(?:[6-9]00|bold|bolder)/.test(style)||/title|heading|name|label/.test(cls)){titleEl=node;title=value;break;}
      }
    }
    if(!titleEl||!title) return null;
    var descEl=null,desc='';
    var paragraphs=el.querySelectorAll('p');
    for(var k=0;k<paragraphs.length;k+=1){
      var pp=text(paragraphs[k]);
      if(pp!==title&&pp.length>=14&&pp.length<=700&&pp!==full){descEl=paragraphs[k];desc=pp;break;}
    }
    if(!descEl){
      var copy=el.querySelectorAll('div');
      for(var m=0;m<copy.length;m+=1){
        var c=copy[m],cv=text(c),cstyle=String(c.getAttribute('style')||'').toLowerCase();
        if(c===titleEl||cv===title||cv===full||cv.length<14||cv.length>700) continue;
        if(cv.indexOf(title)===0&&cv.length>title.length+10) continue;
        if(c.querySelector('h1,h2,h3,h4,table,ul,ol')) continue;
        if(/line-height|font-size|color/.test(cstyle)||c.children.length<=2){descEl=c;desc=cv;break;}
      }
    }
    if(!descEl||!validCard(title,desc,productTitle)) return null;
    return candidate(title,desc,detectIcon(el,title,desc),250,el,'authored-loose');
  }

  function findAuthoredCluster(description,productTitle){
    var groups=[];
    var parents=description.querySelectorAll('div,section,article');
    for(var i=0;i<parents.length;i+=1){
      var parent=parents[i],strict=[],loose=[];
      for(var j=0;j<parent.children.length;j+=1){
        var s=cardData(parent.children[j],productTitle);
        if(s){strict.push(s);loose.push(s);continue;}
        var l=looseCardData(parent.children[j],productTitle);
        if(l) loose.push(l);
      }
      var cards=strict.length>=2?strict:loose;
      if(cards.length<2||cards.length>8) continue;
      var style=String(parent.getAttribute('style')||'').toLowerCase();
      var cls=String(parent.className||'').toLowerCase();
      var visual=/display\s*:\s*(?:grid|flex)/.test(style)||/grid|cards|benefit|summary|resumen|feature|mechanism|research/.test(cls);
      var context=parent,ctx='',summary=false,benefits=false,peptide=false;
      for(var d=0;context&&context!==description&&d<5;d+=1){ctx+=' '+norm(text(context)).slice(0,900);context=context.parentElement;}
      summary=/resumen rapido|lo esencial en segundos/.test(ctx);
      benefits=/beneficios|benefits|ventajas|puntos clave|caracteristicas destacadas/.test(ctx);
      peptide=/mecanismos? de accion|areas? de investigacion|investigacion documentada/.test(ctx);
      if(strict.length<2&&!visual&&!QUICK_LABEL.test(ctx)) continue;
      var score=cards.length*20+(visual?45:0)+(summary?160:0)+(benefits?80:0)+(peptide?55:0);
      groups.push({cards:cards.slice(0,4),container:parent,removeContainer:false,preserveSource:peptide&&!summary&&!benefits,score:score});
    }
    if(!groups.length) return null;
    groups.sort(function(a,b){return b.score-a.score;});
    return groups[0];
  }

  function nextCopy(heading){
    var node=heading.nextElementSibling;
    for(var i=0;node&&i<3;i+=1,node=node.nextElementSibling){
      if(node.matches&&node.matches('p')){var v=text(node);if(v.length>=12)return v;}
      if(node.matches&&node.matches('div')&&!node.querySelector('h1,h2,h3,h4,table,ul,ol')){var d=text(node);if(d.length>=12&&d.length<=700)return d;}
      if(node.matches&&node.matches('h1,h2,h3,h4')) break;
    }
    var parent=heading.parentElement;
    if(parent){
      var p=direct(parent,'p');
      if(p&&p!==heading){var pv=text(p);if(pv.length>=12)return pv;}
    }
    return '';
  }
  function headingCandidates(description,productTitle){
    var out=[];
    var headings=description.querySelectorAll('h2,h3,h4');
    for(var i=0;i<headings.length;i+=1){
      var h=headings[i],title=text(h),key=norm(title),desc=nextCopy(h);
      if(!desc||!validCard(title,desc,productTitle)) continue;
      var score=h.tagName==='H3'||h.tagName==='H4'?175:105;
      if(/beneficio|ventaja|memoria|enfoque|energia|proteccion|soporte|sinerg|potencia|formato|pureza|investigacion|mecanismo/.test(key)) score+=55;
      if(/que es/.test(key)) score+=25;
      if(QUICK_LABEL.test(key)) score+=20;
      out.push(candidate(title,desc,detectIcon(h.parentElement,title,desc),score,h.parentElement,'heading-copy'));
    }
    return out;
  }

  var FACT_SCORE=[
    [/^(?:ingrediente activo|principio activo|compuesto|activo principal|nombre)$/i,190],
    [/^(?:clase|clasificacion|categor[ií]a|tipo)$/i,175],
    [/^(?:pureza|pureza declarada|estandarizacion|grado quimico)$/i,170],
    [/^(?:presentacion|contenido|cantidad neta|unidades|forma del producto|formato)$/i,160],
    [/^(?:formula|formula molecular)$/i,150],
    [/^(?:cas|cas #|numero cas)$/i,145],
    [/^(?:peso molecular|masa molecular)$/i,140],
    [/^(?:secuencia|secuencia peptidica|forma quimica)$/i,135],
    [/^(?:marca|fabricante|proveedor)$/i,80]
  ];
  function factScore(label){
    var clean=compactTitle(label);
    for(var i=0;i<FACT_SCORE.length;i+=1) if(FACT_SCORE[i][0].test(clean)) return FACT_SCORE[i][1];
    return 0;
  }
  function addFact(out,label,value,el,bonus){
    var title=compactTitle(label),desc=firstMeaningful(value),score=factScore(title)+(bonus||0);
    if(!score||!validCard(title,desc,'')) return;
    if(desc.length>220) return;
    out.push(candidate(title,desc,detectIcon(el,title,desc),score,el,'structured-fact'));
  }
  function tableCandidates(description){
    var out=[];
    description.querySelectorAll('table tr').forEach(function(row){
      var cells=row.querySelectorAll(':scope > th,:scope > td');
      if(cells.length<2) cells=row.querySelectorAll('th,td');
      for(var i=0;i+1<cells.length;i+=2){addFact(out,text(cells[i]),text(cells[i+1]),row,15);}
    });
    description.querySelectorAll('dl').forEach(function(dl){
      var terms=dl.querySelectorAll('dt');
      for(var i=0;i<terms.length;i+=1){
        var dd=terms[i].nextElementSibling;
        if(dd&&dd.tagName==='DD') addFact(out,text(terms[i]),text(dd),terms[i].parentElement,10);
      }
    });
    return out;
  }
  function listCandidates(description){
    var out=[];
    description.querySelectorAll('li').forEach(function(li){
      var raw=text(li).replace(/^[→◆✦•·\-–—✓✔]+\s*/,'').trim();
      var m=raw.match(/^([^:]{2,48}):\s*(.{2,220})$/);
      if(!m) return;
      addFact(out,m[1],m[2],li,5);
    });
    return out;
  }
  function identityCandidates(root){
    var out=[];
    root.querySelectorAll('[data-nm-identity-list] > div').forEach(function(row){
      var dt=row.querySelector('dt'),dd=row.querySelector('dd');
      if(dt&&dd) addFact(out,text(dt),text(dd),row,25);
    });
    return out;
  }
  function introCandidates(description,productTitle){
    var out=[];
    var headings=description.querySelectorAll('h1,h2');
    for(var i=0;i<headings.length;i+=1){
      var h=headings[i],key=norm(text(h)),desc=nextCopy(h);
      if(!desc||desc.length<18||desc.length>700||unsafe(key,desc)) continue;
      if(key===norm(productTitle)||/que es/.test(key)){
        out.push(candidate('Qué es',desc,semanticIcon('Qué es',desc),95,h,'intro'));
        break;
      }
    }
    if(!out.length){
      var p=description.querySelector('p');
      if(p){var pv=text(p);if(pv.length>=18&&pv.length<=700)out.push(candidate('Descripción',pv,semanticIcon('Descripción',pv),45,p,'intro'));}
    }
    return out;
  }
  function nativeCandidates(root){
    var out=[];
    var type=root.getAttribute('data-nm-product-type')||'';
    var vendor=root.getAttribute('data-nm-product-vendor')||'';
    var presentation=root.getAttribute('data-nm-product-presentation')||'';
    if(type) out.push(candidate('Clasificación',type,semanticIcon('Clasificación',type),55,null,'native'));
    if(presentation) out.push(candidate('Presentación',presentation,'💊',50,null,'native'));
    if(vendor) out.push(candidate('Marca',vendor,'🏷️',35,null,'native'));
    return out;
  }

  function dedupeAndPick(candidates,max){
    candidates.sort(function(a,b){return b.score-a.score;});
    var out=[],seenT={},seenD={};
    for(var i=0;i<candidates.length&&out.length<max;i+=1){
      var c=candidates[i];
      var t=norm(c.title),d=norm(compactCopy(c.desc));
      if(!t||!d||seenT[t]||seenD[d]) continue;
      /* Avoid near-duplicate generic labels when a stronger candidate exists. */
      var duplicate=false;
      for(var j=0;j<out.length;j+=1){
        var ot=norm(out[j].title),od=norm(compactCopy(out[j].desc));
        if((t.indexOf(ot)!==-1||ot.indexOf(t)!==-1)&&Math.min(t.length,ot.length)>7) duplicate=true;
        if((d.indexOf(od)!==-1||od.indexOf(d)!==-1)&&Math.min(d.length,od.length)>28) duplicate=true;
      }
      if(duplicate) continue;
      seenT[t]=1;seenD[d]=1;out.push(c);
    }
    return out;
  }
  function compose(root,description,productTitle){
    var cluster=findAuthoredCluster(description,productTitle);
    var all=[];
    if(cluster){
      cluster.cards.forEach(function(c,index){c.score=420-index;all.push(c);});
    }
    headingCandidates(description,productTitle).forEach(function(c){all.push(c);});
    tableCandidates(description).forEach(function(c){all.push(c);});
    listCandidates(description).forEach(function(c){all.push(c);});
    identityCandidates(root).forEach(function(c){all.push(c);});
    introCandidates(description,productTitle).forEach(function(c){all.push(c);});
    nativeCandidates(root).forEach(function(c){all.push(c);});
    return {cards:dedupeAndPick(all,4),cluster:cluster};
  }

  function cleanEmpty(description){
    Array.prototype.slice.call(description.querySelectorAll('div,section,article')).reverse().forEach(function(el){
      if(!text(el)&&!el.querySelector('img,svg,table,ul,ol')) el.remove();
    });
  }
  function removeSource(description,cluster){
    if(!cluster||cluster.preserveSource||description.getAttribute('data-nm-preserve-shopify-description')==='true') return;
    /* Remove only the exact authored cards that were promoted. Structured facts,
       tables and paragraphs remain available in Profundiza. */
    cluster.cards.forEach(function(card){if(card.el&&card.el.isConnected) card.el.remove();});
    cleanEmpty(description);
  }
  function build(target,cards){
    target.innerHTML='';
    cards.forEach(function(card){
      var article=document.createElement('article');
      article.className='nmps__benefit nmps__benefit--rich';
      article.innerHTML='<div class="nmps__benefit-icon" aria-hidden="true"></div><div class="nmps__benefit-copy"><h3></h3><p></p></div>';
      article.querySelector('.nmps__benefit-icon').textContent=card.icon||semanticIcon(card.title,card.desc);
      article.querySelector('h3').textContent=compactTitle(card.title);
      var copy=compactCopy(card.desc);
      article.querySelector('p').textContent=copy;
      article.querySelector('p').setAttribute('title',firstMeaningful(card.desc));
      target.appendChild(article);
    });
  }
  function signature(root,description){
    var raw=norm(text(description));
    return [root.getAttribute('data-nm-product-id')||'',root.getAttribute('data-nm-product-title')||'',raw.length,raw.slice(0,140),raw.slice(-90)].join('|');
  }
  function render(root){
    if(!root) return false;
    var target=root.querySelector('[data-nm-quick-cards]');
    var description=root.querySelector('[data-nm-description]');
    if(!target||!description) return false;

    var before=signature(root,description);
    var existing=target.querySelectorAll('.nmps__benefit--rich').length;
    if(root.dataset.nmQuickCardsSignature===before&&existing>=2) return true;
    if(root.dataset.nmQuickCardsSignature===before&&existing<2&&root.__nmQuickCardsCache&&root.__nmQuickCardsCache.signature===before){
      build(target,root.__nmQuickCardsCache.cards);
      return true;
    }

    /* Instant navigation can reuse the same shell. A changed product/description
       must invalidate the old ready flag and old card HTML. */
    target.innerHTML='';
    root.removeAttribute('data-nm-quick-cards-ready');
    root.removeAttribute('data-nm-quick-cards-no-source');

    var result=compose(root,description,root.getAttribute('data-nm-product-title')||'');
    if(!result.cards.length){
      root.dataset.nmQuickCardsSignature=before;
      root.dataset.nmQuickCardsNoSource='1';
      return false;
    }
    build(target,result.cards);
    removeSource(description,result.cluster);
    root.dataset.nmQuickCardsReady='1';
    root.dataset.nmQuickCardsSignature=signature(root,description);
    root.__nmQuickCardsCache={
      signature:root.dataset.nmQuickCardsSignature,
      cards:result.cards.map(function(card){return {title:card.title,desc:card.desc,icon:card.icon,score:card.score,kind:card.kind};})
    };
    return true;
  }
  function scan(){
    if(scanning) return;
    scanning=true;
    try{document.querySelectorAll('.nmps').forEach(render);}finally{scanning=false;}
  }
  function schedule(){
    if(scheduled) return;
    scheduled=window.requestAnimationFrame(function(){scheduled=0;scan();});
  }

  window.NMGlobalQuickCards={version:VERSION,scan:scan,render:render};
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',scan,{once:true});
  else scan();
  window.addEventListener('pageshow',scan);
  document.addEventListener('shopify:section:load',scan);
  document.addEventListener('shopify:section:reorder',scan);
  document.addEventListener('shopify:section:select',scan);

  if(window.MutationObserver){
    var observer=new MutationObserver(function(mutations){
      for(var i=0;i<mutations.length;i+=1){
        if(mutations[i].addedNodes&&mutations[i].addedNodes.length){schedule();return;}
      }
    });
    observer.observe(document.documentElement,{childList:true,subtree:true});
  }
  setTimeout(scan,80);setTimeout(scan,350);setTimeout(scan,1200);
})();
